var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@emotion/styled';
import { space } from 'styled-system';
import { Button } from '../../../common/components/Button';
export var TransitionedIconButton = styled.button(space, function (props) {
    var hidden = props.hidden, hideToRight = props.hideToRight, hideToLeft = props.hideToLeft, delay = props.delay, timeout = props.timeout;
    return __assign(__assign(__assign({ position: 'relative', opacity: hidden ? 0 : 1, pointerEvents: hidden ? 'none' : 'initial', transitionProperty: 'opacity, right, left', alignSelf: 'center', fontSize: 0 }, (hideToRight && { right: hidden ? '-40px' : 0 })), (hideToLeft && { left: hidden ? '-40px' : 0 })), (hidden
        ? {
            transitionTimingFunction: 'ease-in',
            transitionDuration: timeout - delay + "ms",
        }
        : {
            transitionTimingFunction: 'ease-out',
            transitionDuration: timeout - delay + "ms",
            // If delay prop is provided, button will appear with delay,
            // and transition will be shorter by `delay` value
            transitionDelay: delay + "ms",
        }));
});
TransitionedIconButton.defaultProps = {
    as: Button,
    styled: false,
    delay: 0,
};
